import { render, staticRenderFns } from "./PackMaterialRelation.vue?vue&type=template&id=e890bc8a&scoped=true&"
import script from "./PackMaterialRelation.vue?vue&type=script&lang=js&"
export * from "./PackMaterialRelation.vue?vue&type=script&lang=js&"
import style0 from "./PackMaterialRelation.vue?vue&type=style&index=0&id=e890bc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e890bc8a",
  null
  
)

export default component.exports